"use client";

import { usePathname } from "next/navigation";
import { getLocale, isLocale, DEFAULT_LOCALE, type LocaleDefinition } from "@/lib/i18n/locales";

/**
 * Current locale derived from the `/[locale]` path segment (client-side).
 * Single source of truth for components that need the active language —
 * e.g. WorldLida's `<L>` reads `lidaCode` from here.
 */
export function useLocale(): LocaleDefinition {
  const pathname = usePathname() || `/${DEFAULT_LOCALE}`;
  const seg = pathname.split("/")[1] ?? "";
  return getLocale(isLocale(seg) ? seg : DEFAULT_LOCALE);
}
